function CustomerTeam() {
  return <div>Customer Team</div>;
}

export default CustomerTeam;
